import React from "react";
import { Pressable } from "react-native";
import { FilterStructure } from "./types";
import styled from "styled-components/native";
import { useTheme } from "styled-components/native";
import { useTypographyStore } from "@redux/slices/typographySlice";
import { VDBText } from "@components/atoms";
import VDBIcon, { IconsVariant } from "@components/icons/VDBIcon";
import { VDBIcons } from "@utils/VDBIcons";

type InactiveOptionProps = {
  info: FilterStructure;
  mIndex: number;
  inActiveData: FilterStructure[];
  addToActiveOptions: any;
};

const InactiveSortingItemComponent = ({
  info,
  mIndex,
  inActiveData,
  addToActiveOptions,
}: InactiveOptionProps) => {
  const theme = useTheme();
  const typography = useTypographyStore();
  const toTestId = (value: string) => value.replace(/\s+/g, "-").toLowerCase();
  const itemKey = toTestId(String(info?.name ?? "unknown"));
  return (
    <InActiveOptionParentContainer
      key={mIndex}
      mLastOption={mIndex === inActiveData?.length - 1}
    >
      <VDBText color={theme["core-06"]} type={typography["Body-R"]}>
        {info.label}
      </VDBText>
      <AddIconContainer
        testID={`sorting.inactive.add.${itemKey}`}
        data-testId={`sorting.inactive.add.${itemKey}`}
      >
        <Pressable
          onPress={() => {
            addToActiveOptions(info);
          }}
        >
          <VDBIcon
            name={VDBIcons.ADD_CIRCLE}
            size={20}
            variant={IconsVariant.VDBCustom}
            color={theme["core-04"]}
          />
        </Pressable>
      </AddIconContainer>
    </InActiveOptionParentContainer>
  );
};

const InActiveOptionParentContainer = styled.View<any>`
  height: 56px;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  border-bottom-width: ${({ mLastOption }) => (mLastOption ? 0 : 1)}px;
  border-color: ${({ theme }) => theme["core-03"]};
`;

const AddIconContainer = styled.View`
  height: 56px;
  align-items: center;
  justify-content: center;
`;

export default InactiveSortingItemComponent;
